import script from "./ActionConfirmationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionConfirmationModal.vue?vue&type=script&setup=true&lang=ts"

import "./ActionConfirmationModal.vue?vue&type=style&index=0&id=bd5c098a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd5c098a"]])

export default __exports__